import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_ITEMS = [
  { label: "La Sfida", href: "#sfida" },
  { label: "La Soluzione", href: "#soluzione" },
  { label: "Risultati", href: "#risultati" },
  { label: "Visione 2026", href: "#visione" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "header-glass border-b border-slate-100 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="https://www.skillvue.ai"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="logo-link"
          className="flex items-center gap-2.5"
        >
          <img
            src="https://cdn.prod.website-files.com/63eb9c5c0665608db409b4df/66cdde23b308922774c4b3e0_logomark.svg"
            alt="Skillvue"
            className="h-7 w-7"
          />
          <img
            src="https://cdn.prod.website-files.com/63eb9c5c0665608db409b4df/66d02c8992a92ee8b5595df6_Skillvue_logo_Type_Black.svg"
            alt="Skillvue"
            className="h-5 hidden sm:block"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNavClick(item.href)}
              className="text-sm font-medium text-slate-600 hover:text-[var(--sv-primary)] transition-colors cursor-pointer"
              data-testid={`nav-${item.href.slice(1)}`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://www.skillvue.ai/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta"
          >
            <Button className="bg-[var(--sv-primary)] hover:bg-[var(--sv-primary-hover)] text-white rounded-md px-5 h-9 text-sm font-medium gap-1.5">
              Contattaci <ArrowRight className="w-3.5 h-3.5" />
            </Button>
          </a>
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 text-slate-700"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <div
          data-testid="mobile-nav"
          className="md:hidden bg-white border-t border-slate-100 shadow-lg"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.href}
                onClick={() => handleNavClick(item.href)}
                className="text-left py-2 text-sm font-medium text-slate-700 hover:text-[var(--sv-primary)] transition-colors"
                data-testid={`mobile-nav-${item.href.slice(1)}`}
              >
                {item.label}
              </button>
            ))}
            <a
              href="https://www.skillvue.ai/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-header-cta"
              className="mt-2"
            >
              <Button className="w-full bg-[var(--sv-primary)] hover:bg-[var(--sv-primary-hover)] text-white rounded-md h-10 text-sm font-medium gap-1.5">
                Contattaci <ArrowRight className="w-3.5 h-3.5" />
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
